<template>
	<div class="bc">
		<div class="forget">
			<el-form :model="numberValidateForm" ref="numberValidateForm" label-width="100px" class="demo-ruleForm" width="500px" :rules="rules">
				<el-form-item label="旧密码" prop="oldPassWord">
					<el-input type="text" v-model="numberValidateForm.oldPassWord" clearable maxlength="18"></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="newPassWord">
					<el-input type="text" v-model="numberValidateForm.newPassWord" clearable maxlength="16"></el-input>
				</el-form-item>
				<div style="text-align: center;margin-bottom: 20px;">忘记密码请联系管理员</div>
				<el-form-item>
					<el-button @click="back">返回</el-button>
					<el-button type="primary" @click="submitForm('numberValidateForm')">修改密码</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			var validateNewPass = (rule, value, callback) => {
				var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/;
				if (reg.test(value)) {
					callback();
				} else {
					return callback(new Error("密码由数字和字母组合，长度在8-16位"))
				}
			};
			return {
				numberValidateForm: {
					newPassWord: '',
					oldPassWord: ''
				},
				rules: {
					oldPassWord: [{
						required: true,
						message: '旧密码不能为空',
						trigger: ["blur", "change"]
					}, ],
					newPassWord: [{
						required: true,
						message: '新密码不能为空',
						trigger: ["blur", "change"]
					}, {
						validator: validateNewPass,
						trigger: ["blur", "change"]
					}],
				}
			};
		},
		methods: {
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (this.numberValidateForm.oldPassWord == this.numberValidateForm.newPassWord) {
							this.$message.warning("旧密码与新密码不能一样")
							return
						}
						this.$http.post("/api/user/editPassWord", {
							oldPassWord: this.numberValidateForm.oldPassWord,
							newPassWord: this.numberValidateForm.newPassWord,
						}).then(res => {
							if (res.data.code == 0) {
								this.$message.success("修改成功")
								this.back()
							}
							if (res.data.code == -1) {
								this.$message.warning(res.data.message)
							}
						}).catch(err => {})
					} else {
						this.$message.error("请填写正确信息")
						return false;
					}
				});
			},
			back() {
				this.$router.go(-1)
			}
		}
	}
</script>

<style scoped="scoped">
	.bc {
		padding-top: 200px;
		width: 100%;
		height: 100%;
		background-image: url(../assets/imgs/bg.jpg);
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: left top;
	}

	.forget {
		width: 30%;
		margin: 0 auto;
		background-color: #fafafa;
		padding: 60px 60px 40px 60px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1)
	}
</style>
